import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/img/logoDrBrunoCorrea.png";
import "./Menu.css";
import BotaoContato from "../BotaoContato/BotaoContato.js";
import { useEffect, useRef, useState } from "react";
import Collapse from "bootstrap/js/dist/collapse";

function Menu() {
  const navigate = useNavigate();

  const [active, setActive] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMobileMenu = () => {
    setMenuOpen(false);
  };

  const goToSection = (id) => {
    navigate("/", { state: { scrollTo: id } });
  };

  const handleMenuClick = (id) => {
    setActive(id);
    closeMobileMenu();
    goToSection(id);
  };

  useEffect(() => {
    const sections = ["sobre", "especialidades", "contato", "enderecos"];

    const handleScroll = () => {
      setScrolled(window.scrollY > 40);

      let current = "home";

      sections.forEach((id) => {
        const element = document.getElementById(id);

        if (element) {
          const top = element.offsetTop - 140;

          if (window.scrollY >= top) {
            current = id;
          }
        }
      });

      setActive(current);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`navbar navbar-expand-lg fixed-top menu-navbar ${
        scrolled ? "menu-scrolled" : ""
      }`}
    >
      <div className="container">
        <Link
          className="navbar-brand d-flex align-items-center"
          to="/"
          onClick={closeMobileMenu}
        >
          <img src={logo} alt="Logo Dr. Bruno Corrêa" className="menu-logo" />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          aria-controls="navbarNav"
          aria-expanded={menuOpen}
          aria-label="Abrir menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}
          id="navbarNav"
        >
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link
                className={`nav-link ${active === "home" ? "active" : ""}`}
                to="/"
                onClick={closeMobileMenu}
              >
                Home
              </Link>
            </li>

            <li className="nav-item">
              <button
                type="button"
                className={`nav-link ${active === "sobre" ? "active" : ""}`}
                onClick={() => handleMenuClick("sobre")}
              >
                Sobre
              </button>
            </li>

            <li className="nav-item">
              <button
                type="button"
                className={`nav-link ${
                  active === "especialidades" ? "active" : ""
                }`}
                onClick={() => handleMenuClick("especialidades")}
              >
                Especialidades
              </button>
            </li>

            <li className="nav-item">
              <button
                type="button"
                className={`nav-link ${active === "contato" ? "active" : ""}`}
                onClick={() => handleMenuClick("contato")}
              >
                Contato
              </button>
            </li>

            <li className="nav-item">
              <button
                type="button"
                className={`nav-link ${
                  active === "enderecos" ? "active" : ""
                }`}
                onClick={() => handleMenuClick("enderecos")}
              >
                Endereços
              </button>
            </li>

            <li className="nav-item mobile-only" onClick={closeMobileMenu}>
              <BotaoContato
                texto="Agendar"
                origem="menu_mobile"
                rota="https://wa.me/5521983132240?text=Vim%20pelo%20site%20e%20gostaria%20de%20mais%20informações%20sobre%20as%20consultas."
              />
            </li>
          </ul>
        </div>

        <div className="desktop-only">
          <BotaoContato
            texto="Agendar"
            origem="menu_desktop"
            rota="https://wa.me/5521983132240?text=Vim%20pelo%20site%20e%20gostaria%20de%20mais%20informações%20sobre%20as%20consultas."
          />
        </div>
      </div>
    </nav>
  );
}

export default Menu;